import { reduxForm, formValueSelector } from 'redux-form/immutable'
import { connect } from 'react-redux'
import { fromJS } from 'immutable'

import PeerInviteForm from './PeerInviteForm'
import { ADMIN_ORGANIZATION_USERS_INVITE_FORM } from 'app/constants/adminOrganization'
import { syncValidate as validate } from 'app/validators/invites/create'
import { invitesFormSubmit } from 'store/entities/organizations/actions'
import { USA_ISO, ISO_CODE } from 'app/constants/phoneCountryCodes'

const mapStateToProps = state => ({
  users: formValueSelector(ADMIN_ORGANIZATION_USERS_INVITE_FORM)(state, `users`),
})

export default connect(mapStateToProps)(
  reduxForm({
    form: ADMIN_ORGANIZATION_USERS_INVITE_FORM,
    initialValues: fromJS({
      users: [{ phoneISO: USA_ISO }],
    }),
    validate,
    onSubmit: (values, dispatch) => {
      const users = values.get('users').map(valuesRow => {
        const phone = valuesRow.get('phone')
        const iso = valuesRow.get('phoneISO')
        if (phone) {
          valuesRow = valuesRow.set('phone', `${ISO_CODE[iso]}${phone}`)
        }
        return valuesRow
      })
      dispatch(invitesFormSubmit(values.set('users', users)))
    },
  })(PeerInviteForm)
)
